import { useRouter } from 'next/router'

import { useStoreDetails } from './useStoreDetails'

export function useStoreUrl() {
  const store = useStoreDetails()
  const router = useRouter()

  const isDevEnv = Boolean(process.env.NODE_ENV === 'development')
  const isPreviewEnv = Boolean(process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview')
  const isStagingEnv = Boolean(
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'staging'
  )

  if (typeof window !== 'undefined') {
    const isApexDomain = !['flecto.store', 'vercel.app'].some((domain) =>
      window.location.host?.includes(domain)
    )

    const domain = (router.asPath.split('/').filter(Boolean))[0]

    if (isDevEnv) {
      return `https://${window.location.host}/${domain}`
    }

    if (isStagingEnv || isPreviewEnv) {
      return `https://${domain}.staging.flecto.store`
    }

    if (isApexDomain) {
      return `https://${window.location.host}`
    }
  }

  return `https://${store?.domain}.flecto.store`
}
